import axios from 'axios';
import { api, headers } from '../../app/conf';

export const refreshTokenService = (refreshToken) => axios({
    method: 'post',
    url: `${api}/access/refresh`,
    data: {},
    headers: {
        ...headers,
        'access-token': refreshToken
    }
});
